export const GET_GIFT_CARDS_LIST = null;
export const SELECTED_GIFT_CARD_ID = null;
export const GET_VALIDATE_GIFT_CODE = null;